import PromptInput from '@/components/buddy/PromptInput';

export default function Prompt() {
  return (
    <div className="py-6">
      <h1 className="text-xl font-semibold mb-4">Prompt Section</h1>
      <div className="py-4 max-w-[50dvw] mx-auto">
        <PromptInput />
      </div>
    </div>
  );
}
